import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var MatchingTypeOrderer = /*#__PURE__*/_createClass(function MatchingTypeOrderer() {
  _classCallCheck(this, MatchingTypeOrderer);
  _defineProperty(this, "orderAnswerKeysForDiagonal", function (answerSummary, answerKeys) {
    var questions = answerSummary.questions;
    var questionKeys = Object.keys(questions);
    var orderedKeys = _toConsumableArray(answerKeys);
    answerKeys.forEach(function (answerKey) {
      questionKeys.forEach(function (questionKey) {
        var question = questions[questionKey];
        if (question.answers[answerKey].distractor) {
          orderedKeys.splice(orderedKeys.indexOf(answerKey), 1);
          orderedKeys.push(answerKey);
        }
      });
    });
    return orderedKeys;
  });
  _defineProperty(this, "orderQuestionKeysForDiagonal", function (answerSummary, questionKeys, orderedAnswerKeys) {
    var questions = answerSummary.questions;
    var orderedQuestionKeys = [];
    orderedAnswerKeys.forEach(function (orderedAnswerKey) {
      questionKeys.forEach(function (questionKey) {
        var question = questions[questionKey];
        if (question.answers[orderedAnswerKey].correct) {
          orderedQuestionKeys.push(questionKey);
        }
      });
    });
    return orderedQuestionKeys;
  });
});
export default new MatchingTypeOrderer();